export default __webpack_public_path__ + "static/media/tool0.29f22a19.png";